unit LoginResponse;
{

/* Initial. */

}
interface

uses
  JS, WEBLib.Dialogs,
  BaseResponse, LoginType;

type
  TLoginResponse = class(TBaseResponse)
  private
    fLogin: TLoginType;
  public
    property Login: TLoginType read fLogin;
    constructor Create(const String_JSON: String);
  end;

implementation

constructor TLoginResponse.Create(const String_JSON: String);
var JSObject_Type: TJSObject;
begin
  inherited Create(String_JSON);

  JSObject_Type := TJSJSON.parseObject(String_JSON);

  fLogin := TLoginType.Create(TJSJSON.stringify(JSObject_Type['login']));
end;

end.
